import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=b0107b76&scoped=true"
import script from "./Project.vue?vue&type=script&lang=ts"
export * from "./Project.vue?vue&type=script&lang=ts"
import style0 from "./Project.vue?vue&type=style&index=0&id=b0107b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0107b76",
  null
  
)

export default component.exports